
import { Factory, Droplet, Flame, Zap, Settings, Beaker, Wind, FlaskConical, TestTube } from "lucide-react";

export const products = [
  {
    category: "Reverse Osmosis (RO) Systems",
    icon: Droplet,
    items: [
      {
        id: "domestic-ro",
        name: "Domestic RO System",
        description: "High-quality RO systems for home use. We are leading manufacturers with a wide range of spares and accessories.",
        specs: ["Compact design", "High purity output", "Low maintenance"],
        image: "https://customer-assets.emergentagent.com/job_cleanwater-tech-1/artifacts/ruimqzol_download.jpg" 
      },
      {
        id: "commercial-ro",
        name: "Commercial RO System",
        description: "Designed to meet brackish water treatment requirements of commercial establishments. Removes salts, bacteria, sugars, proteins, and particles > 150-250 Dalton.",
        specs: ["High rejection rate", "Robust membrane technology", "Commercial grade pumps"],
        image: "https://customer-assets.emergentagent.com/job_cleanwater-tech-1/artifacts/vc5pj5g0_download%20%281%29.jpg" 
      },
      {
        id: "industrial-ro",
        name: "Industrial RO System",
        description: "Large-scale purification for power generation, petroleum refining, and chemical processing. Backed by leading component suppliers.",
        specs: ["Heavy duty operation", "Custom capacity", "Advanced pre-treatment"],
        image: "https://customer-assets.emergentagent.com/job_7a26661a-be9e-43eb-91d8-593628f0b2e0/artifacts/gnrifj3b_industrial-ro-plant.jpeg" 
      }
    ]
  },
  {
    category: "Industrial Plants & Machinery",
    icon: Factory,
    items: [
      {
        id: "etp",
        name: "Effluent Treatment Plant (ETP)",
        description: "Sophisticated & innovative solution to purify industrial effluent water. Precision designed to effectively solve environmental pollution problems created by wastewater.",
        specs: ["High quality purification", "Pollution control compliance", "Industrial grade design"],
        image: "https://images.unsplash.com/photo-1533077162801-86490c593afb"
      },
      {
        id: "steam-boilers",
        name: "Steam Boilers",
        description: "High-efficiency steam generation systems. Available in various fuel options including HSD, LDO, Furnace Oil, Gas, Rice Husk, Baggase, Coal, and Wood.",
        specs: ["Capacity: From 30 Kg/hr onwards", "Pressure: 10.54 Kg/Cm2 onwards", "Multi-fuel compatibility"],
        image: "https://customer-assets.emergentagent.com/job_7a26661a-be9e-43eb-91d8-593628f0b2e0/artifacts/b6m9y7m9_steam-boiler.jpg"
      },
      {
        id: "thermic-heaters",
        name: "Thermic Fluid Heaters",
        description: "Fully automatic heating processors designed to heat thermic fluid oil up to 300°C. Features high efficiency and operates at very low pressure (nearly atmospheric).",
        specs: ["Capacity: 50,000 to 10 Lakh K.Cal/hr", "Max Temp: Up to 300°C", "Fully Automatic Control"],
        image: "https://customer-assets.emergentagent.com/job_7a26661a-be9e-43eb-91d8-593628f0b2e0/artifacts/ncf6c3rd_thermic-fluid-heater.jpg"
      },
      {
        id: "hot-water-gen",
        name: "Hot Water Generators",
        description: "Compact, noiseless, and rigid fully automatic generators suitable for Hotels, Hospitals, Resorts, Swimming Pools, and Central Heating Systems.",
        specs: ["Capacity: 50,000 to 15 Lakh K.Cal/hr", "Fuel: Oil/Gas Fired", "Max Temp: Up to 200°C"],
        image: "https://customer-assets.emergentagent.com/job_7a26661a-be9e-43eb-91d8-593628f0b2e0/artifacts/3ro3bfpa_hot-water-boilers-500x500.jpg.webp"
      }
    ]
  },
  {
    category: "Cooling Towers",
    icon: Wind,
    items: [
      {
        id: "cooling-tower",
        name: "Industrial Cooling Tower System",
        description: "Leading manufacturer & exporter of cooling towers for electricity generating, petroleum refining, chemical processing, sugar, and steel industries.",
        specs: ["Types: FRP, Wooden, RCC", "Draft: Atmospheric, Forced, Induced", "High cooling efficiency"],
        image: "https://customer-assets.emergentagent.com/job_cleanwater-tech-1/artifacts/tgoq87tu_Industrial%20Cooling%20Tower%20Plant.jpeg"
      }
    ]
  },
  {
    category: "Water Treatment Plants",
    icon: Zap,
    items: [
      {
        id: "softening-plant",
        name: "Softening Plant",
        description: "Effective water softening solutions to remove hardness causing minerals.",
        specs: ["Ion Exchange Technology", "Auto/Manual Regeneration", "Consistent Soft Water"],
        image: "https://customer-assets.emergentagent.com/job_cleanwater-tech-1/artifacts/1evvymyz_Softening%20Plant.jpeg"
      },
      {
        id: "dm-plant",
        name: "Demineralised (DM) Plant",
        description: "Produces mineral-free water for industrial boilers and process use.",
        specs: ["Cation & Anion Columns", "High Purity Output", "Conductivity Monitoring"],
        image: "https://customer-assets.emergentagent.com/job_7a26661a-be9e-43eb-91d8-593628f0b2e0/artifacts/ph07oku7_dm-water-treatment-img.jpg"
      },
      {
        id: "filtration-plant",
        name: "Water Filtration Plants",
        description: "Sand filters, carbon filters, and multi-grade filters for suspended solids removal.",
        specs: ["Multi-media filtration", "Backwash capability", "High flow rates"],
        image: "https://customer-assets.emergentagent.com/job_cleanwater-tech-1/artifacts/0udxlxkx_Water%20Filteration%20Plant.jpeg"
      }
    ]
  },
  {
    category: "Chemicals: Cooling Water Treatment",
    icon: FlaskConical,
    items: [
      {
        id: "bgc-1010",
        name: "Scale & Corrosion Preventives",
        description: "Comprehensive range of chemicals to prevent scale and corrosion in cooling water systems.",
        specs: [
          "BGC-1010: Scale Preventive",
          "BGC-101: Scale & Corrosion Preventive",
          "BGC-701: Scale & Corrosion Preventive"
        ],
        image: "https://images.unsplash.com/photo-1576086213369-97a306d36557"
      },
      {
        id: "bgc-dispersants",
        name: "Dispersants & Inhibitors",
        description: "Specialized inhibitors and dispersants for optimal system performance.",
        specs: [
          "BGC-1100: Dispersant",
          "BGC-1101: Corrosion Inhibitor (O.C)",
          "BGC-1102: Corrosion Inhibitor (C.C.)",
          "BGC-1103: Alkalinity Reducer"
        ],
        image: "https://customer-assets.emergentagent.com/job_cleanwater-tech-1/artifacts/rw8h7ka2_Dispersants%20%26%20Inhibitors.jpeg"
      },
      {
        id: "bgb-biocides",
        name: "Biocides & Algaecides",
        description: "Control biological growth, algae, and microbes in cooling towers.",
        specs: [
          "BGC-1104: Bio-Dispersant",
          "BGB-105: Multi Treat",
          "BGB-103: Algaecide",
          "BGB-104: Microbiocide"
        ],
        image: "https://images.unsplash.com/photo-1532187863486-abf9dbad1b69"
      }
    ]
  },
  {
    category: "Chemicals: Boiler Water Treatment",
    icon: Flame,
    items: [
      {
        id: "bg-booster",
        name: "pH Boosters & Conditioners",
        description: "Maintain optimal pH levels and condition sludge to prevent boiler damage.",
        specs: [
          "BG-03: Anti Scalant",
          "BG-003: Scale Preventive/Corrosion Inhibitor",
          "BG-0030: Sludge Conditioner",
          "BG-04: pH Booster",
          "BG-05: Spl. pH Booster"
        ],
        image: "https://customer-assets.emergentagent.com/job_cleanwater-tech-1/artifacts/0ham6x2g_pH%20booster%20%26%20Conditioners.jpeg"
      },
      {
        id: "bg-scavenger",
        name: "Oxygen Scavengers & Treatment",
        description: "Remove dissolved oxygen and prevent corrosion in steam boilers.",
        specs: [
          "BG-06: Alkalinity Reducer",
          "BG-07: Oxygen Scavenger (Sulphite Base)",
          "BG-08: Oxygen Scavenger (Hydrazine Base)",
          "BG-109: Vapour Phase Corrosion Inhibitor",
          "BG-110: Multi Purpose Treatment"
        ],
        image: "https://customer-assets.emergentagent.com/job_cleanwater-tech-1/artifacts/xylksknp_Oxygen%20Scavengers%20%26%20Treatment.jpeg"
      }
    ]
  },
  {
    category: "Chemicals: Descaling & Specialities",
    icon: Beaker,
    items: [
      {
        id: "descaling-chem",
        name: "Descaling Chemicals",
        description: "Powerful agents for removing scale deposits from industrial equipment.",
        specs: [
          "BG-09: Descaling Chemicals",
          "BG-10: Sp. Descaling",
          "Descaling Chemicals (Powder Form)",
          "Passivator",
          "On Line Cleaning Chemicals"
        ],
        image: "https://customer-assets.emergentagent.com/job_cleanwater-tech-1/artifacts/3nh905s7_Descaling%20chemichal.jpeg"
      },
      {
        id: "speciality-chem",
        name: "Other Specialities Chemicals",
        description: "Fuel additives and cleaning agents for specific industrial applications.",
        specs: [
          "BG-F: Fireside Chemicals",
          "BG-FA: Fuel Additive for HSD",
          "BG-FAL: Fuel Additive for L.D.O",
          "BG-FO: Fuel Additive for F.O.",
          "Chemicals for Cleaning Radiator AC, Fins",
          "Floor Cleaner"
        ],
        image: "https://customer-assets.emergentagent.com/job_cleanwater-tech-1/artifacts/45i4v3ro_Other%20Specialities%20chemichal.jpeg"
      }
    ]
  },
  {
    category: "Water Testing & Analysis",
    icon: TestTube,
    items: [
      {
        id: "drop-test-kit",
        name: "Comprehensive Drop Test Kit",
        description: "Complete portable kit for on-site water analysis and quality testing.",
        specs: [
          "Total Hardness, Sulphate, Alkalinity",
          "Manganese, Calcium, Phosphate",
          "Chloride, Silica, Fluoride",
          "Magnesium, Arsenic, Iron",
          "Amines, Nitrate, Chlorine"
        ],
        image: "https://customer-assets.emergentagent.com/job_cleanwater-tech-1/artifacts/0ho9upri_Comprehensive%20drop%20test%20kit.jpeg"
      }
    ]
  },
  {
    category: "Spares & Accessories",
    icon: Settings,
    items: [
      {
        id: "plant-spares",
        name: "DM / Softening Plant Spares",
        description: "Genuine high-quality spares for plant maintenance.",
        specs: [
          "FRP Vessels",
          "Multiport Valves",
          "Injector Assembly",
          "Resin (T-40, T-42 Cations, Anions)",
          "Pressure Regulation Valve"
        ],
        image: "https://images.unsplash.com/photo-1581092335397-9583eb92d232"
      },
      {
        id: "meters",
        name: "Instrumentation",
        description: "Precision meters for monitoring water parameters.",
        specs: [
          "Digital Conductivity Meter",
          "pH Meter",
          "TDS Meter",
          "Flow Meters",
          "Pressure Gauges"
        ],
        image: "https://images.unsplash.com/photo-1518152006812-edab29b069ac"
      }
    ]
  }
];
